import { PlatformSiteAri } from '@atlassian/ari';

/**
 * Creates a PlatformSiteAri from a siteId.
 * Returns null if the siteId is invalid or if PlatformSiteAri.create throws an exception.
 * This prevents page crashes when invalid cloudIds propagate through the system.
 *
 * @param siteId - The site ID (cloudId/workspaceId) to convert to a PlatformSiteAri
 * @returns The PlatformSiteAri string representation, or null if creation fails
 */
export const createPlatformSiteAri = (siteId: string | null | undefined): string | null => {
	if (!siteId) {
		return null;
	}

	try {
		return PlatformSiteAri.create({ siteId }).toString();
	} catch {
		// Fail silently - invalid siteIds can propagate from manual cloudId changes
		// and we don't want to crash the page or expose errors to customers
		return null;
	}
};
